<div class="main_body">
  <app-page-header
    title="定型ユーザーデータ"
    i18n-title="@@adminSystem.userDataTemplateList.title.list"
    subtitle="定型ユーザーデータの閲覧・編集を行います。"
    i18n-subtitle="@@adminSystem.userDataTemplateList.label.description"
    icon="template"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- M3 Expandable Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder" i18n="@@adminSystem.userDataTemplateList.placeholder.filter">テンプレート名フィルタ</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="'テンプレート名フィルタ'"
              i18n-aria-label="@@adminSystem.userDataTemplateList.search.ariaLabel"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSystem.userDataTemplateList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <!-- Action buttons - right aligned -->
          <div class="table-toolbar__actions">
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="openCreateUserDataTemplatepDialog()"
              matTooltip="新規作成"
              aria-label="新規作成"
              i18n-matTooltip="@@adminSystem.userDataTemplateList.tooltip.create"
              i18n-aria-label="@@adminSystem.userDataTemplateList.ariaLabel.create"
            >
              <mat-icon>add</mat-icon>
            </button>
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSystem.userDataTemplateList.tooltip.refresh"
              i18n-aria-label="@@adminSystem.userDataTemplateList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="5" />
          } @else {
          <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="desc">

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;" i18n="@@adminSystem.userDataTemplateList.table.name"> テンプレート名 </th>
              <td mat-cell *matCellDef="let row">
                <span>{{row.name}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="preview">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;" i18n="@@adminSystem.userDataTemplateList.table.preview"> ユーザーデータ設定</th>
              <td mat-cell *matCellDef="let row"> {{row.preview}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="opeUserDataTemplateDetailsDialog(row)">
            </tr>
          </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
